import { useEffect } from 'react';

export const useScrollIntoViewOnError = (
  element?: Element | null,
  condition = false,
) => {
  useEffect(() => {
    if (
      element
      && condition
      && element.getBoundingClientRect().top > window.innerHeight
    ) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [condition, element]);
};
